export default __webpack_public_path__ + "static/Tangle6-0c77bc1a5fa4b9dc2ac826ddb66a0c7e.jpg";